import React from 'react';

const Gap = (props: { gap: string }) => {
  return <div className={props.gap}></div>;
};

export default Gap;
